module.exports = __webpack_public_path__ + "img/violet_036.4315de76.png";